/* istanbul ignore file */
import { FormFieldsData, useFormContext, SearchInputProps, SearchInput } from 'framework/form';
import { AssignmentTargetType } from '../assignmentTargetService';
import { useServiceCatalogService } from 'domain/shared/serviceCatalog';

interface AssignmentServiceCatalogTargetInputProps extends Omit<SearchInputProps, 'searchRequest'> {
  source: string;
  label?: string;
  initialLabel?: string;
  searchString?: string;
  nameSource?: string;
  mapResults?: (service: any) => void;
  isVisible?: boolean | ((data: FormFieldsData) => boolean);
  props?: any;
}

const AssignmentServiceCatalogTargetInput = ({
  mapResults,
  source,
  ...props
}: AssignmentServiceCatalogTargetInputProps) => {
  const { getServiceSuggestions } = useServiceCatalogService();
  const { data, onChangeCallback } = useFormContext();

  const mapResponse = (target: any) => ({
    id: target.id,
    text: target.name,
  });

  const onTargetChange = (value: any) => {
    if (onChangeCallback) {
      onChangeCallback({
        ...data,
        budgetId: null,
        target: {
          id: null,
          targetId: value?.target?.id,
          type: AssignmentTargetType.SERVICE_CATALOG_SERVICE,
        },
      });
    }
  };

  const getInitValue = async () => {
    const initialId = data?.target?.targetId;
    if (!initialId) return null;
    const response = await getServiceSuggestions({ filter: { id: { eq: initialId } } });
    const service = response?.result?.[0];

    return service?.name || null;
  };

  return (
    <SearchInput
      {...props}
      onChangeCallback={onTargetChange}
      source={source}
      searchRequest={getServiceSuggestions}
      defaultFilter={{ status: { ne: 'ARCHIVED' } }}
      searchString="name"
      noResultMessage="No Service Catalog Targets are found."
      mapResults={mapResults || mapResponse}
      customGetInitialValue={getInitValue}
    />
  );
};

export default AssignmentServiceCatalogTargetInput;
